const QUESTIONS = [
  {
    q: "Czy potrzebuję mikrofonu i kamery?",
    a: "Mikrofon — tak, jest niezbędny do rozmów z awatarem AI i lekcji z lektorem. Kamera tylko na lekcjach live z lektorem (opcjonalnie). Wszystko działa w przeglądarce, nic nie instalujesz.",
  },
  {
    q: "Jak naprawdę działa awatar AI?",
    a: "Arthur to model językowy z syntezą głosu i animowaną mimiką (Simli). Rozumie kontekst, koryguje błędy w locie, dostosowuje poziom do Twoich postępów. Nie czyta gotowych skryptów — naprawdę z Tobą rozmawia.",
  },
  {
    q: "Czy lektorzy są certyfikowani?",
    a: "Tak. Wszyscy nasi lektorzy mają certyfikaty CELTA/DELTA lub równoważne i minimum 3 lata doświadczenia. Native speakerzy dostępni w planie Premium.",
  },
  {
    q: "Co jeśli odpuszczę lekcję?",
    a: "Możesz przełożyć lekcję bez kosztów do 12h przed startem. Awatar AI jest dostępny 24/7 — nawet jak opuścisz lekcję live, postępy nie spadają.",
  },
  {
    q: "Czy mogę zrezygnować w każdej chwili?",
    a: "Tak. Bez kar, bez umów na czas określony. Anulujesz subskrypcję w panelu — dostęp masz do końca opłaconego okresu.",
  },
  {
    q: "Jakie języki?",
    a: "Na start: angielski (wszystkie poziomy A1–C2). W kolejnych miesiącach: niemiecki, hiszpański i włoski. Zapisz się, żeby dostać powiadomienie przy starcie nowego języka.",
  },
];

export function FAQ(): JSX.Element {
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="text-xs text-lime-500 uppercase tracking-widest font-semibold mb-3">FAQ</div>
          <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight">
            Najczęstsze pytania
          </h2>
        </div>
        <div className="space-y-3">
          {QUESTIONS.map((item) => (
            <details
              key={item.q}
              className="group bg-ink-800 border border-ink-700 hover:border-ink-600 rounded-xl overflow-hidden transition"
            >
              <summary className="cursor-pointer list-none px-5 py-4 flex items-center justify-between gap-4 text-white font-medium">
                <span>{item.q}</span>
                <svg
                  className="w-5 h-5 text-lime-500 flex-shrink-0 transition-transform group-open:rotate-180"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"/>
                </svg>
              </summary>
              <div className="px-5 pb-5 text-ink-300 text-sm leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
